import { Countrys } from '../services/countrys.service';

export class Country {
  private _name: string;
  private _cca2: string;
  constructor(private country: Countrys) {
    this._name = country.name.common;
    this._cca2 = country.cca2;
  }

  public get name() {
    return this._name;
  }

  public get cca2() {
    return this._cca2;
  }
}
